import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.local_bills;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

  
export const getLocalBillByLocalId = async (localId: number) => {
    return await api.get(`/GetLocalBillByLocalId/${localId}`, {
    });
}

export const getAllLocalBillsByLocalIdAndRangeDate = async (
  localId: number,
  startDate: string,
  endDate: string
) => {
  return await api.get(
    `/GetAllLocalBillsByLocalIdAndRangeDate/${localId}/${startDate}/${endDate}`
  );
}

export const createLocalBill = async (billData: any) => {
    return await api.post('/CreateLocalBill', billData, {
    });
}

export const deleteLocalBillById = async (billId: number) => {
    return await api.delete(`/DeleteLocalBill/${billId}`);
}

export const updateLocalBill = async (billId: number, billData: any) => {
  return await api.put(`/UpdateLocalBill/${billId}`, billData);
}